import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataedoDownloadsModelResponse } from '../responses/dataedo-downloads-response';
import {environment} from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class DataedoDownloadsService {
    constructor(private http: HttpClient) {}

    public getDownloads(): Observable<DataedoDownloadsModelResponse> {
        return this.http.get<DataedoDownloadsModelResponse>(`${environment.apiUrl}v1/dataedo-downloads`);
    }
}
